/** Строки классов контролов: вид supply (высота 32 px, 12.5px текст). Две семьи — `btn*`/`input`/`label` (тренды) и `inputClass`/`selectClass` (проект). */

export const btn =
  "inline-flex h-8 items-center gap-1.5 whitespace-nowrap rounded-[var(--radius-ui)] border border-border bg-bg px-2.5 text-[12.5px] text-fg-muted transition-colors hover:bg-bg-hover hover:text-fg disabled:cursor-not-allowed disabled:opacity-50";

export const btnPrimary =
  "inline-flex h-8 items-center gap-1.5 whitespace-nowrap rounded-[var(--radius-ui)] border border-accent bg-accent px-3 text-[12.5px] font-medium text-bg transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50";

export const btnGhost =
  "inline-flex h-7 items-center gap-1 whitespace-nowrap rounded-[var(--radius-ui)] px-1.5 text-[12px] text-fg-faint transition-colors hover:bg-bg-hover hover:text-fg disabled:cursor-not-allowed disabled:opacity-50";

export const input =
  "h-8 min-w-0 rounded-[var(--radius-ui)] border border-border bg-bg px-2 text-[12.5px] text-fg outline-none placeholder:text-fg-faint focus:border-accent";

export const label = "text-[11.5px] text-fg-faint";

export const inputClass =
  "h-8 rounded-[var(--radius-ui)] border border-border bg-bg px-2.5 text-[12.5px] text-fg outline-none placeholder:text-fg-faint focus:border-accent";

export const selectClass =
  "h-8 max-w-full rounded-[var(--radius-ui)] border border-border bg-bg px-2 text-[12.5px] text-fg outline-none focus:border-accent";
